module.exports = __webpack_public_path__ + "static/img/par4.f6c945b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par4.png
// module id = IsIw
// module chunks = 0